import React from 'react';
import { Result, Button } from 'antd';

class ReportErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Report Error:', error, errorInfo);
    // Log to error reporting service (e.g., Sentry)
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/intelligent-reports';
  };

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status="error"
          title="Something went wrong"
          subTitle="An error occurred while displaying the report. Please try again."
          extra={[
            <Button type="primary" key="retry" onClick={this.handleReset}>
              Retry
            </Button>,
            <Button key="home" href="/">
              Go Home
            </Button>,
          ]}
        />
      );
    }

    return this.props.children;
  }
}

export default ReportErrorBoundary;
